import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import Backend from "i18next-http-backend";
import Angie from "~/utils/angie";
import { momentLocalizationMap } from "~/utils/localization";
// import LanguageDetector from 'i18next-browser-languagedetector';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    backend: {
      // path where resources get loaded from
      loadPath: function (language, namespace) {
        let dir = Array.isArray(language) ? language[0] : language;
        let version = Angie && Angie.frontend_version ? Angie.frontend_version : new Date().toJSON().slice(0, 7);
        let base = "";
        if (window.AC && !window.AC.on_demand && window.AC.root_url) {
          base = window.AC.root_url;
        }
        return `${base}/locales/${dir}/${namespace.toString()}.json?v=${version}`;
      },
    },
    lng: "en",
    fallbackLng: "en",
    load: "currentOnly",
    supportedLngs: Object.keys(momentLocalizationMap),
    // debug: process.env.NODE_ENV === "development",
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
